<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini"
      >归属记录</el-button
    >
    <el-dialog
      title="归属记录"
      :visible.sync="moveDialogVisible"
      width="80%"
      center
      @close="clear"
    >
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="updateBelongList" style="width: 100%">
        <el-table-column prop="channelUserId" label="用户ID" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="preInviteBy" label="修改前邀请人" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.preInviteBy }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="preParentUids"
          label="修改前代理UID"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.preChannelUserId }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="inviteBy" label="修改后邀请人" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.inviteBy }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="channelId" label="修改后代理UID" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channelUserId }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag">
        <pagination
          :size="updateBelongPagination.size"
          :total="updateBelongTotal"
          :page="updateBelongPagination.page"
          @pageChanged="pageChanged"
        ></pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

import Pagination from "components/pagination";
import { PAGINATION } from "../../constants";

export default {
  data() {
    return {
      moveDialogVisible: false,
      userId: "",
    };
  },
  components: {
    Pagination,
  },
  computed: {
    ...mapState("partnerList", [
      "updateBelongPagination",
      "updateBelongList",
      "updateBelongTotal",
    ]),
  },

  methods: {
    ...mapActions("partnerList", ["updateBelong"]),

    openDialog() {
      this.moveDialogVisible = true;
      this.updateBelong({ ...PAGINATION, userId: this.userId });
    },
    handleSearch() {
      this.updateBelong({ ...PAGINATION, userId: this.userId });
    },
    clear() {
      this.moveDialogVisible = false;
    },
    pageChanged(pagination) {
      this.updateBelong({ ...pagination, userId: this.userId });
    },
  },
};
</script>

<style lang="less" src="../../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.item {
  display: flex;

  height: 100%;
  justify-content: flex-start;
  align-items: center;

  .ipt {
  }
}
</style>
